import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CopyrightCircleOutlinedSvg from "@ant-design/icons-svg/es/asn/CopyrightCircleOutlined";
import AntdIcon from '../components/AntdIcon';
var CopyrightCircleOutlined = function CopyrightCircleOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    icon: CopyrightCircleOutlinedSvg
  }));
};
var RefIcon = /*#__PURE__*/React.forwardRef(CopyrightCircleOutlined);
if (process.env.NODE_ENV !== 'production') {
  RefIcon.displayName = 'CopyrightCircleOutlined';
}
export default RefIcon;